// Shared locale utilities
import { getActiveLanguage } from '@haldor/ui';
import Moment from 'moment';

export const normalizeLocale = (lang) => {
	if (!lang) return undefined;
	const l = String(lang).toLowerCase();

	const map = {
		'en-us': 'en',
		'en-gb': 'en-gb',
		'sv-se': 'sv',
		'sv': 'sv',
		'nb-no': 'nb',
		'nn-no': 'nn',
		'da-dk': 'da',
		'fi-fi': 'fi'
	};

	let normalized = map[l];
	if (!normalized) {
		const parts = l.split(/[-_]/);
		normalized = parts[0] || l;
	}

	// Try to set Moment locale for side effects (safe if locale not loaded)
	try {
		Moment.locale(normalized);
	} catch (e) {
		// ignore
	}

	return normalized;
};

export const getNormalizedActiveLanguage = () => normalizeLocale(getActiveLanguage());

// Map normalized language to MUI X Date Pickers locale export
import * as pickersLocales from '@mui/x-date-pickers/locales';

export const getPickersLocale = (normalizedLang) => {
	if (!normalizedLang) return null;

	const map = {
		en: 'enUS',
		'en-gb': 'enGB',
		sv: 'svSE',
		nb: 'nbNO',
		nn: 'nnNO',
		da: 'daDK',
		fi: 'fiFI'
	};

	const key = map[normalizedLang] || map[normalizedLang.split('-')[0]];
	if (!key) return null;

	return pickersLocales[key] || null;
};

